import React, { useEffect, useState, useCallback, useContext } from "react";
import QuoteDetailsHeaderNewBrand from "./QuoteDetailsHeaderNewBrand";
import { useParams, useNavigate, useLoaderData, json } from "react-router-dom";
import ItemList from "../Items/ItemList";
import styles from "./QuoteDetailsNewBrand.module.css";
import RequestForQuote from "../RFQ/RequestForQuote";
import useHttp from "../../hooks/use-http";
import AppContext from "../../store/app-context";
import { parseCookies } from "nookies";
import Breadcrumb from "../UI/Breadcrumb";
import QuoteExpanded from "../History/QuoteExpanded";

const QuoteDetailsNewBrand = (props) => {
  const [quote, setQuote] = useState();
  const { webRef } = useParams();
  const { sendRequest: getQuoteDetails } = useHttp();
  const [isLoading, setIsLoading] = useState(true);
  const [isAPIError, setIsAPIError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("Error fetching data...");
  const [destWebRef, setDestWebRef] = useState();

  sessionStorage.removeItem("submittedWebRef");

  const navigate = useNavigate();

  const appCtx = useContext(AppContext);
 
  let home = 'Home';
  let my_biorad = 'My Bio-rad';
  let quote_title = 'Quotes';
  let label_quoteDetail = 'Quote detail';
  let label_expiredQuote = 'This Quote Has Expired.';
  let label_expiredRenew = 'If you are still interested in the items on this list, you have the option to renew the quote and extend the expiration date.';
  let label_expiredCopy = 'If you are still interested in the items on this list, you can submit a new quote for the latest pricing available to you.';
  let label_quoteSubmittedRenewal = 'Quote submitted for renewal';

  const existCookies = parseCookies();
  let newBrandStyle
  if (appCtx && appCtx.bioradResources) {
    home = appCtx.bioradResources.Home ? appCtx.bioradResources.Home : 'Home';
    my_biorad = appCtx.bioradResources.MyBioRad ? appCtx.bioradResources.MyBioRad : 'My Bio-rad';
    quote_title = appCtx.bioradResources.QuoteTitle ?? 'Quotes';
    label_quoteDetail = appCtx.bioradResources.Quote_Detail ? appCtx.bioradResources.Quote_Detail : 'Quote detail';
    label_expiredQuote = appCtx.bioradResources.Expired_For_Quote_Request_Msg ? appCtx.bioradResources.Expired_For_Quote_Request_Msg : 'This Quote Has Expired.';
    label_expiredRenew = appCtx.bioradResources.Resubmit_For_Quote_Request_Msg ? appCtx.bioradResources.Resubmit_For_Quote_Request_Msg : 'If you are still interested in the items on this list, you have the option to renew the quote and extend the expiration date.';
    label_expiredCopy = appCtx.bioradResources.Copy_To_New_Quote_Request_Msg ? appCtx.bioradResources.Copy_To_New_Quote_Request_Msg : 'If you are still interested in the items on this list, you can submit a new quote for the latest pricing available to you.';
    label_quoteSubmittedRenewal = appCtx.bioradResources.Quote_Submitted_Renewal ? appCtx.bioradResources.Quote_Submitted_Renewal : 'Quote submitted for renewal';
  }
  useEffect(() => {
    fetch(appCtx.envProp.webServer + 'standalone/my-biorad/leftnav.page', { credentials: 'include' })
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const navElement = doc.querySelector('#block-biorad-content');
        if (navElement) {
          // document.querySelector('.my-nav').append(navElement);
          // jQuery('.my-nav').html(navElement.outerHTML);
          document.querySelector('.my-nav').innerHTML = navElement.outerHTML;
          const target = document.querySelector('.my-nav');

          if (target) {
            const currentPath = window.location.pathname;
            const links = target.querySelectorAll('a[href]');

            links.forEach(link => {
              const linkPath = new URL(link.href, window.location.origin).pathname;
              const quoteAppRegex = /^\/quote-app\/quotes(\/[^\/]*)?$/;

              if (linkPath === currentPath || (quoteAppRegex.test(currentPath) && quoteAppRegex.test(linkPath))) {
                link.classList.add('active');
              }
            });

            // handle script tags
            const executeScripts = (container) => {
              const scripts = container.querySelectorAll('script');
              
              scripts.forEach(originalScript => {
                const newScript = document.createElement('script');
                
                Array.from(originalScript.attributes).forEach(attr => {
                    newScript.setAttribute(attr.name, attr.value);
                });
                
                if (originalScript.textContent) {
                    let scriptContent = originalScript.textContent.trim();
                    
                    // Replace $(document).ready() with $(function()) 
                    // $(function()) executes immediately if DOM is ready, unlike $(document).ready() 
                    // which may not fire if DOM is already ready when jQuery loads
                    scriptContent = scriptContent.replace(
                      /\$\(document\)\.ready\s*\(\s*function\s*\(\s*\)\s*\{/g,
                      '$(function() {'
                    );
                    
                    // Ensure jQuery is available when script executes
                    // Since we're in React's useEffect, DOM is already ready
                    if (scriptContent.includes('$(') || scriptContent.includes('jQuery(')) {
                      scriptContent = `(function() {
                        var $ = window.jQuery || window.$;
                        if (typeof $ === 'function' && typeof checkNotificationFlag === 'function') {
                          ${scriptContent}
                        } else {
                          // Wait a bit for jQuery if not immediately available
                          var attempts = 0;
                          var checkJQuery = setInterval(function() {
                            attempts++;
                            $ = window.jQuery || window.$;
                            if (typeof $ === 'function' && typeof checkNotificationFlag === 'function') {
                              clearInterval(checkJQuery);
                              ${scriptContent}
                            } else if (attempts >= 50) {
                              // Give up after 10 second (50 * 200ms)
                              clearInterval(checkJQuery);
                              console.warn('jQuery not available after waiting, script may not execute');
                            }
                          }, 200);
                        }
                      })();`;
                    }
                    
                    newScript.textContent = scriptContent;
                }

                originalScript.parentNode.replaceChild(newScript, originalScript);
              });
            };
            executeScripts(target);
          }
        }
      })
      .catch((err) => {
        console.error('Failed to load navigation:', err);
      });
  }, [appCtx.envProp.webServer]);

  useEffect(() => {
    if (appCtx && appCtx.envProp) {
      newBrandStyle = existCookies.rebrandEnabled
        ? existCookies.rebrandEnabled
        : appCtx.envProp.react_app_new_brand_style ? appCtx.envProp.react_app_new_brand_style : false;
    }
  }, [appCtx])

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    const setQuoteData = (quoteData) => {
      setQuote(quoteData);
      setIsLoading(false);
    };

    if (props?.quote) {
      setQuoteData(props.quote);
    } else {
      setIsLoading(true);
      //getQuoteHandler();
      getQuoteDetails(
        { url: "/quoteservices/rfqs/rfq/" + webRef },
        setQuoteData,
        "json"
      ).catch((error) => {
        if (error && error.message) {
          setErrorMsg(error.message);
        }
        setIsAPIError(true);
        setIsLoading(false);
      });
    }
    //setIsLoading(false);
  }, []);

  const copyQuoteHandler = useCallback(async () => {
    setIsLoading(true);

    const setDestinationWebRef = (data) => {
      setDestWebRef(data);
    }

    const copyURL = "/quoteservices/rfqs/copy/" + webRef;
    const response = await fetch(copyURL, { method: 'GET' });

    if (!response.ok) {
      const data = await response.json();
      if (data && data.status === 'fail') {
        setErrorMsg(data.message);
      }
      setIsLoading(false);
    } else {
      const data = await response.json();
      if (data && data.status === 'fail') {
        setErrorMsg(data.message);
      } else {
        setDestinationWebRef(data);
      }
    }
    setIsLoading(false);
  }, [])

  const renewQuoteHandler = useCallback(async () => {
    setIsLoading(true);

    const setQuoteData = (quoteData) => {
      setQuote(quoteData);
      setIsLoading(false);
    };

    const copyURL = "/quoteservices/rfqs/renew/" + webRef;
    const response = await fetch(copyURL, { method: 'GET' });

    if (!response.ok) {
      const data = await response.json();
      if (data && data.status === 'fail') {
        setErrorMsg(data.message);
      }
      setIsLoading(false);
    } else {
      const data = await response.json();
      if (data && data.status === 'fail') {
        setErrorMsg(data.message);
      } else {
        setQuoteData(data);
        if (newBrandStyle === 'true' && data.quoteId) {
          const deleteNotificationURL = appCtx.envProp.appServer + "etlapi/my-biorad/delete-renewed-quote-notification/quote/" + data.quoteId + "/type/Expired";
          await fetch(deleteNotificationURL, { method: 'DELETE' });
        }

      }
    }
    setIsLoading(false);
  }, [appCtx])

  //If copy clicked then redirect to RFQ home with new rfq id.
  if (destWebRef) {
    navigate('/' + destWebRef);
  }
  //if open quote then redirect to RFQ home
  if (quote?.quoteStatus && quote.quoteStatus === 'Not Submitted') {
    navigate('/' + webRef);
  }

  const isRenewed = quote && (quote.quoteStatus === 'Pending Renewal') ? true : false;

  const cntryLang = appCtx.lang.toLowerCase() + "-" + appCtx.country.toLowerCase();
  const myBioRadLink = appCtx.envProp.appServer + "bc/" + cntryLang + "/my-biorad";

  return (
    <div className={styles.pageLayout}>
      <div id={styles.nav} className="my-nav">
      </div>
      <div className={styles.pageContent}>
        <Breadcrumb>
          <Breadcrumb.Item>
            <a href="/">{home}</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a href={myBioRadLink}>{my_biorad}</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a href={"/" + appCtx?.envProp?.appName + "/quotes"}>{quote_title}</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            {label_quoteDetail}
          </Breadcrumb.Item>
        </Breadcrumb>
        <div className={styles.quote__headerMod}>
          {isRenewed && (<div className={styles.infoBox}><span className={styles.bioicons_circle_exclamation}></span><p>{label_quoteSubmittedRenewal}</p></div>)}
          {isAPIError && <p>{errorMsg}</p>}
          {isLoading && !isAPIError && <p className={styles.loading_ring}></p>}
          {!isLoading && !isAPIError && (
            <>
              {quote.isExpired && quote.isRenewable && (
                <div className={styles.infoBox}>
                  <span className={styles.bioicons_circle_exclamation}></span>
                  <p>
                    <span><strong>{label_expiredQuote}</strong> {label_expiredRenew}</span>
                  </p>
                </div>
              )}
              {quote.isExpired && !quote.isRenewable && (
                <div className={styles.infoBox}>
                  <span className={styles.bioicons_circle_exclamation}></span>
                  <p>
                    <span><strong>{label_expiredQuote}</strong> {label_expiredCopy}</span>
                  </p>
                </div>
              )}

              <QuoteDetailsHeaderNewBrand quote={quote} />
              <h2 className={styles.detailHeader}>{label_quoteDetail}</h2>
              <div className={styles.cart_os_module}>
                <div className={styles.cart_module}>
                  {quote &&
                    quote.quoteLineEntityList &&
                    quote.quoteLineEntityList.length > 0 && (
                      <QuoteExpanded background="background1" quoteDetail={true} quote={quote} />)}
                </div>
                <div className="right-col-wrapper">
                  <RequestForQuote
                    isNew={"true"}
                    total={
                      quote && quote.formattedTotalPrice
                        ? quote.formattedTotalPrice
                        : ""
                    }
                    isEditable={false}
                    quote={quote ? quote : null}
                    copyQuoteHandler={copyQuoteHandler}
                    renewQuoteHandler={renewQuoteHandler}
                    isRenewed={isRenewed}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default QuoteDetailsNewBrand;

export async function loader({ request, params }) {
  const webRef = params.webRef;

  const response = await fetch("/quoteservices/rfqs/rfq/" + webRef);

  if (!response.ok) {
    throw json(
      { message: "Could not fetch details for selected quote." },
      {
        status: 500,
      }
    );
  } else {
    return response;
  }
}
